export const scheduleConstants = {
    GETALL_REQUEST: 'SCHEDULE_GETALL_REQUEST',
    GETALL_SUCCESS: 'SCHEDULE_GETALL_SUCCESS',
    GETALL_FAILURE: 'SCHEDULE_GETALL_FAILURE',
  
    DELETE_REQUEST: 'SCHEDULE_DELETE_REQUEST',
    DELETE_SUCCESS: 'SCHEDULE_DELETE_SUCCESS',
    DELETE_FAILURE: 'SCHEDULE_DELETE_FAILURE',

    CREATE_REQUEST: 'SCHEDULE_CREATE_REQUEST',
    CREATE_SUCCESS: 'SCHEDULE_CREATE_SUCCESS',
    CREATE_FAILURE: 'SCHEDULE_CREATE_FAILURE',

    UPDATE_REQUEST: 'SCHEDULE_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'SCHEDULE_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'SCHEDULE_UPDATE_FAILURE',
  };